const product_data = [
  {
    sku:'DK1002',
    id:1,
    title:'Epple iPad Pro 10.5-inch Cellular 64G',
    slug:'epple-ipad-pro-10-5-inch-cellular-64g',
    image:'/images/product/tp-1.jpg',
    category:{
      name:'Laptop & Computer',
      child:'laptop'
    },
    price: 150,
    discount_percentage: 10,
    quantity: 100,
    related_images:[
      '/images/product/tp-1.jpg',
      '/images/product/tp-2.jpg',
      '/images/product/tp-3.jpg',
    ],
    brand:'Logitech',
    description:
      "Designed by Hans J. Wegner in 1949 as one of the first models created especially for Carl Hansen & Son, and produced since 1950. The last of a series of chairs wegner designed based on inspiration from antique Chinese armchairs. The gently rounded top together with the back and seat offers a variety of comfortable seating positions,ideal for both long visits to the dining table and relaxed lounging. The standard passage, used since the 1500s. A light chair, easy to move around the dining table and about the room. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Lorem ipsum dolor sit amet conse ctetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Sit amet conse ctetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
    additionalInformation: [
      {
        key: "Weight",
        value: "2 lbs",
      },
      {
        key: "Dimensions",
        value: "12 × 16 × 19 inches",
      },
      {
        key: "Product",
        value: "Purchase this product on rag-bone.com",
      },
      {
        key: "Color",
        value: "Gray, Black",
      },
      {
        key: "Size",
        value: "S, M, L, XL",
      },
      {
        key: "Model",
        value: "model-12345",
      },
      {
        key: "Care Info",
        value: "Standard shipping: $5,95",
      },
      {
        key: "Brand",
        value: "logitech",
      },
    ],
    tags: ["Apple", "iPad", "Laptop", "Computer"],
    feature_lists:['Bass and Stereo Sound.','Display with 3088 x 1440 pixels resolution.','Memory, Storage & SIM: 12GB RAM, 256GB.','Android v10.0 Operating system.'],
    reviews:[
      {
        id:1,
        rating: 4,
        comment: 'Good product',
        name: 'John Doe',
        user: '/images/author/author-sm-1.jpeg',
        date:'Jan 20, 2024',
      }
    ],
    sizes:['S','M','L','XL'],
    colors:['black','blue'],
    sold: 10,
    createdAt: '2021-02-15T10:00:00.000Z',
    updatedAt: '2021-02-15T10:00:00.000Z',
  },
  {
    sku:'CK1005',
    id:2,
    title:'Men Size Yellow Basketball Jerseys',
    slug:'men-size-yellow-basketball-jerseys',
    image:'/images/product/tp-2.jpg',
    category:{
      name:'Fashion & Clothing',
      child:'fashion'
    },
    price: 150,
    discount_percentage: 5,
    quantity: 50,
    related_images:[
      '/images/product/tp-2.jpg',
      '/images/product/tp-1.jpg',
      '/images/product/tp-4.jpg',
    ],
    brand:'Sony',
    description:
      "Designed by Hans J. Wegner in 1949 as one of the first models created especially for Carl Hansen & Son, and produced since 1950. The last of a series of chairs wegner designed based on inspiration from antique Chinese armchairs. The gently rounded top together with the back and seat offers a variety of comfortable seating positions,ideal for both long visits to the dining table and relaxed lounging. The standard passage, used since the 1500s. A light chair, easy to move around the dining table and about the room. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Lorem ipsum dolor sit amet conse ctetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Sit amet conse ctetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
    additionalInformation: [
      {
        key: "Weight",
        value: "2 lbs",
      },
      {
        key: "Dimensions",
        value: "12 × 16 × 19 inches",
      },
      {
        key: "Product",
        value: "Purchase this product on rag-bone.com",
      },
      {
        key: "Color",
        value: "Gray, Black",
      },
      {
        key: "Size",
        value: "S, M, L, XL",
      },
      {
        key: "Model",
        value: "model-12345",
      },
      {
        key: "Care Info",
        value: "Standard shipping: $5,95",
      },
      {
        key: "Brand",
        value: "logitech",
      },
    ],
    tags: ['Jersey','Basketball'],
    feature_lists:['Bass and Stereo Sound.','Display with 3088 x 1440 pixels resolution.','Memory, Storage & SIM: 12GB RAM, 256GB.','Android v10.0 Operating system.'],
    reviews:[
      {
        id:1,
        rating: 5,
        comment: 'Good product',
        name: 'Mary Doe',
        user: '/images/author/author-sm-1.jpeg',
        date:'Jan 20, 2024',
      }
    ],
    sizes:['S','M'],
    colors:['yellow'],
    sold: 15,
    createdAt: '2021-02-15T10:00:00.000Z',
    updatedAt: '2021-02-15T10:00:00.000Z',
  },
  {
    sku:'EK1007',
    id:3,
    title:'Xbox Wireless Game Controller Pink',
    slug:'xbox-wireless-game-controller-pink',
    image:'/images/product/tp-3.jpg',
    category:{
      name:'Digital & Electronics',
      child:'electronics'
    },
    price: 250,
    discount_percentage: 10,
    quantity: 40,
    related_images:[
      '/images/product/tp-3.jpg',
      '/images/product/tp-2.jpg',
      '/images/product/tp-5.jpg',
    ],
    brand:'Samsung',
    description:
      "Designed by Hans J. Wegner in 1949 as one of the first models created especially for Carl Hansen & Son, and produced since 1950. The last of a series of chairs wegner designed based on inspiration from antique Chinese armchairs. The gently rounded top together with the back and seat offers a variety of comfortable seating positions,ideal for both long visits to the dining table and relaxed lounging. The standard passage, used since the 1500s. A light chair, easy to move around the dining table and about the room. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Lorem ipsum dolor sit amet conse ctetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Sit amet conse ctetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
    additionalInformation: [
      {
        key: "Weight",
        value: "2 lbs",
      },
      {
        key: "Dimensions",
        value: "12 × 16 × 19 inches",
      },
      {
        key: "Product",
        value: "Purchase this product on rag-bone.com",
      },
      {
        key: "Color",
        value: "Gray, Black",
      },
      {
        key: "Size",
        value: "S, M, L, XL",
      },
      {
        key: "Model",
        value: "model-12345",
      },
      {
        key: "Care Info",
        value: "Standard shipping: $5,95",
      },
      {
        key: "Brand",
        value: "logitech",
      },
    ],
    tags: ['Digital','Video Game'],
    feature_lists:['Bass and Stereo Sound.','Display with 3088 x 1440 pixels resolution.','Memory, Storage & SIM: 12GB RAM, 256GB.','Android v10.0 Operating system.'],
    reviews:[
      {
        id:1,
        rating: 4.5,
        comment: 'Good product',
        name: 'Sarah Doe',
        user: '/images/author/author-sm-1.jpeg',
        date:'Jan 20, 2024',
      }
    ],
    sizes:['L','XL'],
    colors:['green','red'],
    sold: 20,
    createdAt: '2021-02-15T10:00:00.000Z',
    updatedAt: '2021-02-15T10:00:00.000Z',
  },
  {
    sku:'BA1002',
    id:4,
    title:'Wireless Bluetooth Over-Ear Headphones',
    slug:'wireless-bluetooth-over-ear-headphones',
    image:'/images/product/tp-4.jpg',
    category:{
      name:'Camera & Headphone',
      child:'headphone'
    },
    price: 180,
    discount_percentage: 10,
    quantity: 30,
    related_images:[
      '/images/product/tp-4.jpg',
      '/images/product/tp-1.jpg',
      '/images/product/tp-3.jpg',
    ],
    brand:'Apple',
    description:
      "Designed by Hans J. Wegner in 1949 as one of the first models created especially for Carl Hansen & Son, and produced since 1950. The last of a series of chairs wegner designed based on inspiration from antique Chinese armchairs. The gently rounded top together with the back and seat offers a variety of comfortable seating positions,ideal for both long visits to the dining table and relaxed lounging. The standard passage, used since the 1500s. A light chair, easy to move around the dining table and about the room. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Lorem ipsum dolor sit amet conse ctetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Sit amet conse ctetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
    additionalInformation: [
      {
        key: "Weight",
        value: "2 lbs",
      },
      {
        key: "Dimensions",
        value: "12 × 16 × 19 inches",
      },
      {
        key: "Product",
        value: "Purchase this product on rag-bone.com",
      },
      {
        key: "Color",
        value: "Gray, Black",
      },
      {
        key: "Size",
        value: "S, M, L, XL",
      },
      {
        key: "Model",
        value: "model-12345",
      },
      {
        key: "Care Info",
        value: "Standard shipping: $5,95",
      },
      {
        key: "Brand",
        value: "logitech",
      },
    ],
    tags: ['Headphones','Wireless'],
    feature_lists:['Bass and Stereo Sound.','Display with 3088 x 1440 pixels resolution.','Memory, Storage & SIM: 12GB RAM, 256GB.','Android v10.0 Operating system.'],
    reviews:[
      {
        id:1,
        rating: 3.5,
        comment: 'Good product',
        name: 'Sarah Doe',
        user: '/images/author/author-sm-1.jpeg',
        date:'Jan 20, 2024',
      }
    ],
    sizes:['S','M'],
    colors:['pink'],
    sold: 25,
    createdAt: '2021-02-15T10:00:00.000Z',
    updatedAt: '2021-02-15T10:00:00.000Z',
  },
  {
    sku:'BA1002',
    id:5,
    title:'Solo3 Wireless On-Ear Headphones',
    slug:'solo3-wireless-on-ear-headphones',
    image:'/images/product/tp-5.jpg',
    category:{
      name:'Camera & Headphone',
      child:'headphone'
    },
    price: 120,
    discount_percentage: 8,
    quantity: 25,
    related_images:[
      '/images/product/tp-5.jpg',
      '/images/product/tp-2.jpg',
      '/images/product/tp-4.jpg',
    ],
    brand:'Deepcool',
    description:
      "Designed by Hans J. Wegner in 1949 as one of the first models created especially for Carl Hansen & Son, and produced since 1950. The last of a series of chairs wegner designed based on inspiration from antique Chinese armchairs. The gently rounded top together with the back and seat offers a variety of comfortable seating positions,ideal for both long visits to the dining table and relaxed lounging. The standard passage, used since the 1500s. A light chair, easy to move around the dining table and about the room. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Lorem ipsum dolor sit amet conse ctetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Sit amet conse ctetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
    additionalInformation: [
      {
        key: "Weight",
        value: "2 lbs",
      },
      {
        key: "Dimensions",
        value: "12 × 16 × 19 inches",
      },
      {
        key: "Product",
        value: "Purchase this product on rag-bone.com",
      },
      {
        key: "Color",
        value: "Gray, Black",
      },
      {
        key: "Size",
        value: "S, M, L, XL",
      },
      {
        key: "Model",
        value: "model-12345",
      },
      {
        key: "Care Info",
        value: "Standard shipping: $5,95",
      },
      {
        key: "Brand",
        value: "logitech",
      },
    ],
    tags: ['Headphones','Wireless'],
    feature_lists:['Bass and Stereo Sound.','Display with 3088 x 1440 pixels resolution.','Memory, Storage & SIM: 12GB RAM, 256GB.','Android v10.0 Operating system.'],
    reviews:[
      {
        id:1,
        rating: 5,
        comment: 'Best product',
        name: 'Will Doe',
        user: '/images/author/author-sm-1.jpeg',
        date:'Jan 20, 2024',
      }
    ],
    sizes:['L','XL'],
    colors:['blue'],
    featured: true,
    sold: 28,
    createdAt: '2021-02-15T10:00:00.000Z',
    updatedAt: '2021-02-15T10:00:00.000Z',
  },
  {
    sku:'AA1003',
    id:6,
    title:'Vifa Bluetooth Portable Wireless Speaker',
    slug:'vifa-bluetooth-portable-wireless-speaker',
    image:'/images/product/tp-6.jpg',
    category:{
      name:'Decor & Furniture',
      child:'decor'
    },
    price: 300,
    discount_percentage: 15,
    quantity: 28,
    related_images:[
      '/images/product/tp-6.jpg',
      '/images/product/tp-1.jpg',
      '/images/product/tp-5.jpg',
    ],
    brand:'Logitech',
    description:
      "Designed by Hans J. Wegner in 1949 as one of the first models created especially for Carl Hansen & Son, and produced since 1950. The last of a series of chairs wegner designed based on inspiration from antique Chinese armchairs. The gently rounded top together with the back and seat offers a variety of comfortable seating positions,ideal for both long visits to the dining table and relaxed lounging. The standard passage, used since the 1500s. A light chair, easy to move around the dining table and about the room. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Lorem ipsum dolor sit amet conse ctetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Sit amet conse ctetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
    additionalInformation: [
      {
        key: "Weight",
        value: "2 lbs",
      },
      {
        key: "Dimensions",
        value: "12 × 16 × 19 inches",
      },
      {
        key: "Product",
        value: "Purchase this product on rag-bone.com",
      },
      {
        key: "Color",
        value: "Gray, Black",
      },
      {
        key: "Size",
        value: "S, M, L, XL",
      },
      {
        key: "Model",
        value: "model-12345",
      },
      {
        key: "Care Info",
        value: "Standard shipping: $5,95",
      },
      {
        key: "Brand",
        value: "logitech",
      },
    ],
    tags: ['Headphones','Wireless'],
    feature_lists:['Bass and Stereo Sound.','Display with 3088 x 1440 pixels resolution.','Memory, Storage & SIM: 12GB RAM, 256GB.','Android v10.0 Operating system.'],
    reviews:[
      {
        id:1,
        rating: 5,
        comment: 'Best product',
        name: 'Kevin Doe',
        user: '/images/author/author-sm-1.jpeg',
        date:'Jan 20, 2024',
      }
    ],
    sizes:['M','XL'],
    colors:['aqua'],
    sold: 32,
    createdAt: '2021-02-15T10:00:00.000Z',
    updatedAt: '2021-02-15T10:00:00.000Z',
  },
  {
    sku:'BB1003',
    id:7,
    title:'APPO R11s 64GB Dual 20MP Cameras',
    slug:'appo-r11s-64gb-dual-20mp-cameras',
    image:'/images/product/tp-7.jpg',
    category:{
      name:'Tablet & Mobile',
      child:'mobile'
    },
    price: 500,
    discount_percentage: 10,
    quantity: 20,
    related_images:[
      '/images/product/tp-4.jpg',
      '/images/product/tp-1.jpg',
      '/images/product/tp-5.jpg',
    ],
    brand:'Samsung',
    description:
      "Designed by Hans J. Wegner in 1949 as one of the first models created especially for Carl Hansen & Son, and produced since 1950. The last of a series of chairs wegner designed based on inspiration from antique Chinese armchairs. The gently rounded top together with the back and seat offers a variety of comfortable seating positions,ideal for both long visits to the dining table and relaxed lounging. The standard passage, used since the 1500s. A light chair, easy to move around the dining table and about the room. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Lorem ipsum dolor sit amet conse ctetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Sit amet conse ctetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
    additionalInformation: [
      {
        key: "Weight",
        value: "2 lbs",
      },
      {
        key: "Dimensions",
        value: "12 × 16 × 19 inches",
      },
      {
        key: "Product",
        value: "Purchase this product on rag-bone.com",
      },
      {
        key: "Color",
        value: "Gray, Black",
      },
      {
        key: "Size",
        value: "S, M, L, XL",
      },
      {
        key: "Model",
        value: "model-12345",
      },
      {
        key: "Care Info",
        value: "Standard shipping: $5,95",
      },
      {
        key: "Brand",
        value: "logitech",
      },
    ],
    tags: ['mobile','sumsung'],
    feature_lists:['Bass and Stereo Sound.','Display with 3088 x 1440 pixels resolution.','Memory, Storage & SIM: 12GB RAM, 256GB.','Android v10.0 Operating system.'],
    reviews:[
      {
        id:1,
        rating: 5,
        comment: 'Best product',
        name: 'Brian Doe',
        user: '/images/author/author-sm-1.jpeg',
        date:'Jan 20, 2024',
      }
    ],
    sizes:['L'],
    colors:['cyan'],
    sold: 35,
    createdAt: '2021-02-15T10:00:00.000Z',
    updatedAt: '2021-02-15T10:00:00.000Z',
  },
  {
    sku:'CB1001',
    id:8,
    title:'Samsang Galaxy A70 128GB Dual-SIM',
    slug:'samsang-galaxy-a70-128gb-dual-sim',
    image:'/images/product/tp-7.jpg',
    category:{
      name:'Tablet & Mobile',
      child:'mobile'
    },
    price: 450,
    discount_percentage: 5,
    quantity: 18,
    related_images:[
      '/images/product/tp-7.jpg',
      '/images/product/tp-3.jpg',
      '/images/product/tp-5.jpg',
    ],
    brand:'Samsung',
    description:
      "Designed by Hans J. Wegner in 1949 as one of the first models created especially for Carl Hansen & Son, and produced since 1950. The last of a series of chairs wegner designed based on inspiration from antique Chinese armchairs. The gently rounded top together with the back and seat offers a variety of comfortable seating positions,ideal for both long visits to the dining table and relaxed lounging. The standard passage, used since the 1500s. A light chair, easy to move around the dining table and about the room. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Lorem ipsum dolor sit amet conse ctetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Sit amet conse ctetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
    additionalInformation: [
      {
        key: "Weight",
        value: "2 lbs",
      },
      {
        key: "Dimensions",
        value: "12 × 16 × 19 inches",
      },
      {
        key: "Product",
        value: "Purchase this product on rag-bone.com",
      },
      {
        key: "Color",
        value: "Gray, Black",
      },
      {
        key: "Size",
        value: "S, M, L, XL",
      },
      {
        key: "Model",
        value: "model-12345",
      },
      {
        key: "Care Info",
        value: "Standard shipping: $5,95",
      },
      {
        key: "Brand",
        value: "logitech",
      },
    ],
    tags: ['mobile','sumsung'],
    feature_lists:['Bass and Stereo Sound.','Display with 3088 x 1440 pixels resolution.','Memory, Storage & SIM: 12GB RAM, 256GB.','Android v10.0 Operating system.'],
    reviews:[
      {
        id:1,
        rating: 5,
        comment: 'Best product',
        name: 'Brian Doe',
        user: '/images/author/author-sm-1.jpeg',
        date:'Jan 20, 2024',
      }
    ],
    sizes:['XXL'],
    colors:['orange'],
    featured: true,
    sold: 0,
    createdAt: '2021-02-15T10:00:00.000Z',
    updatedAt: '2021-02-15T10:00:00.000Z',
  },
  {
    sku:'EE1001',
    id:9,
    title:'Epple Watch SE Gold Aluminum',
    slug:'epple-watch-se-gold-aluminum',
    image:'/images/product/tp-8.jpg',
    category:{
      name:'Digital & Electronics',
      child:'digital'
    },
    price: 190,
    discount_percentage: 5,
    quantity: 15,
    related_images:[
      '/images/product/tp-2.jpg',
      '/images/product/tp-3.jpg',
      '/images/product/tp-5.jpg',
    ],
    brand:'Apple',
    description:
      "Designed by Hans J. Wegner in 1949 as one of the first models created especially for Carl Hansen & Son, and produced since 1950. The last of a series of chairs wegner designed based on inspiration from antique Chinese armchairs. The gently rounded top together with the back and seat offers a variety of comfortable seating positions,ideal for both long visits to the dining table and relaxed lounging. The standard passage, used since the 1500s. A light chair, easy to move around the dining table and about the room. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Lorem ipsum dolor sit amet conse ctetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Sit amet conse ctetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
    additionalInformation: [
      {
        key: "Weight",
        value: "2 lbs",
      },
      {
        key: "Dimensions",
        value: "12 × 16 × 19 inches",
      },
      {
        key: "Product",
        value: "Purchase this product on rag-bone.com",
      },
      {
        key: "Color",
        value: "Gray, Black",
      },
      {
        key: "Size",
        value: "S, M, L, XL",
      },
      {
        key: "Model",
        value: "model-12345",
      },
      {
        key: "Care Info",
        value: "Standard shipping: $5,95",
      },
      {
        key: "Brand",
        value: "logitech",
      },
    ],
    tags: ['watch','apple'],
    feature_lists:['Bass and Stereo Sound.','Display with 3088 x 1440 pixels resolution.','Memory, Storage & SIM: 12GB RAM, 256GB.','Android v10.0 Operating system.'],
    reviews:[
      {
        id:1,
        rating: 5,
        comment: 'Best product',
        name: 'Chris Doe',
        user: '/images/author/author-sm-1.jpeg',
        date:'Jan 20, 2024',
      }
    ],
    sizes:['XL'],
    colors:['gray'],
    featured: true,
    sold: 42,
    createdAt: '2021-03-15T10:00:00.000Z',
    updatedAt: '2021-05-15T10:00:00.000Z',
  },
  {
    sku:'FF1001',
    id:10,
    title:'G951s Pink Stereo Gaming Headset',
    slug:'g951s-pink-stereo-gaming-headset',
    image:'/images/product/tp-9.jpg',
    category:{
      name:'Camera & Headphone',
      child:'headphone'
    },
    price: 120,
    discount_percentage: 8,
    quantity: 15,
    related_images:[
      '/images/product/tp-3.jpg',
      '/images/product/tp-2.jpg',
      '/images/product/tp-6.jpg',
    ],
    brand:'Sony',
    description:
      "Designed by Hans J. Wegner in 1949 as one of the first models created especially for Carl Hansen & Son, and produced since 1950. The last of a series of chairs wegner designed based on inspiration from antique Chinese armchairs. The gently rounded top together with the back and seat offers a variety of comfortable seating positions,ideal for both long visits to the dining table and relaxed lounging. The standard passage, used since the 1500s. A light chair, easy to move around the dining table and about the room. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Lorem ipsum dolor sit amet conse ctetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Sit amet conse ctetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
    additionalInformation: [
      {
        key: "Weight",
        value: "2 lbs",
      },
      {
        key: "Dimensions",
        value: "12 × 16 × 19 inches",
      },
      {
        key: "Product",
        value: "Purchase this product on rag-bone.com",
      },
      {
        key: "Color",
        value: "Gray, Black",
      },
      {
        key: "Size",
        value: "S, M, L, XL",
      },
      {
        key: "Model",
        value: "model-12345",
      },
      {
        key: "Care Info",
        value: "Standard shipping: $5,95",
      },
      {
        key: "Brand",
        value: "logitech",
      },
    ],
    tags: ['headphones','sony'],
    feature_lists:['Bass and Stereo Sound.','Display with 3088 x 1440 pixels resolution.','Memory, Storage & SIM: 12GB RAM, 256GB.','Android v10.0 Operating system.'],
    reviews:[
      {
        id:1,
        rating: 5,
        comment: 'Best product',
        name: 'Chris Doe',
        user: '/images/author/author-sm-1.jpeg',
        date:'Jan 20, 2024',
      }
    ],
    sizes:['L','XL'],
    colors:['blue'],
    featured: true,
    sold: 45,
    createdAt: '2021-03-15T10:00:00.000Z',
    updatedAt: '2021-05-15T10:00:00.000Z',
  },
  {
    sku:'GB1001',
    id:11,
    title:'Men’s Short-Sleeve Pocket Oxford Shirt',
    slug:'men-s-short-sleeve-pocket-oxford-shirt',
    image:'/images/product/tp-10.jpg',
    category:{
      name:'Fashion & Clothing',
      child:'clothing'
    },
    price: 80,
    discount_percentage: 0,
    quantity: 10,
    related_images:[
      '/images/product/tp-1.jpg',
      '/images/product/tp-2.jpg',
      '/images/product/tp-8.jpg',
    ],
    brand:'Logitech',
    description:
      "Designed by Hans J. Wegner in 1949 as one of the first models created especially for Carl Hansen & Son, and produced since 1950. The last of a series of chairs wegner designed based on inspiration from antique Chinese armchairs. The gently rounded top together with the back and seat offers a variety of comfortable seating positions,ideal for both long visits to the dining table and relaxed lounging. The standard passage, used since the 1500s. A light chair, easy to move around the dining table and about the room. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Lorem ipsum dolor sit amet conse ctetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Sit amet conse ctetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
    additionalInformation: [
      {
        key: "Weight",
        value: "2 lbs",
      },
      {
        key: "Dimensions",
        value: "12 × 16 × 19 inches",
      },
      {
        key: "Product",
        value: "Purchase this product on rag-bone.com",
      },
      {
        key: "Color",
        value: "Gray, Black",
      },
      {
        key: "Size",
        value: "S, M, L, XL",
      },
      {
        key: "Model",
        value: "model-12345",
      },
      {
        key: "Care Info",
        value: "Standard shipping: $5,95",
      },
      {
        key: "Brand",
        value: "logitech",
      },
    ],
    tags: ['fashion','clothing'],
    feature_lists:['Bass and Stereo Sound.','Display with 3088 x 1440 pixels resolution.','Memory, Storage & SIM: 12GB RAM, 256GB.','Android v10.0 Operating system.'],
    reviews:[
      {
        id:1,
        rating: 5,
        comment: 'Best product',
        name: 'Chris Doe',
        user: '/images/author/author-sm-1.jpeg',
        date:'Jan 20, 2024',
      }
    ],
    sizes:['L','XL'],
    colors:['blue'],
    featured: true,
    sold: 60,
    createdAt: '2021-03-15T10:00:00.000Z',
    updatedAt: '2021-05-15T10:00:00.000Z',
  },
]

export default product_data;